import React from 'react';
import { Helmet } from 'react-helmet';
import CreateOrUpdateShopForm from 'components/Form/Tenant/CreateOrUpdateShopForm';
import { Container } from 'reactstrap';

const ShopFormPage: React.FC = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <CreateOrUpdateShopForm />
      </Container>
    </div>
  );
};

export default ShopFormPage;
